'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('dashboard', {
      url: '/account/dashboard?sta_recid',
      template: '<dashboard></dashboard>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/dashboard/dashboard.routes.js